// Lighting condition options (CLAUDE.md §6 rule 5).
// Stored in journal.photos[].lighting.

export const LIGHTING_OPTIONS = [
  { id: 'daylight-window',  label: 'Daylight — window' },
  { id: 'daylight-outdoor', label: 'Daylight — outdoor' },
  { id: 'indoor-lamp',      label: 'Indoor lamp' },
  { id: 'mixed',            label: 'Mixed / unsure' },
];
